export default __webpack_public_path__ + "c512918566142453a1465658989fcb86.png";